/**
 * Middleware de roteamento que realiza duas funções principais:
 * 1. Prevenção contra URLs maliciosas
 * 2. Normalização de URLs com barras no final
 *
 * @param {Object} context - Contexto da rota Nuxt.js
 * @param {Object} context.route - Objeto contendo informações da rota atual
 * @param {Function} context.redirect - Função para redirecionamento
 */
export default function ({ route, redirect }) {
  // Desestruturação do objeto route para obter path, query e hash
  let { path, query, hash } = route

  /**
   * Verificação de padrões maliciosos na URL:
   * 1. Duas ou mais barras no início (ex: //example.com)
   * 2. Barras invertidas ou codificadas (ex: \ ou %5C)
   * 3. URLs começando com http:// ou https:// (tentativa de SSRF)
   * 4. Barras normais codificadas (ex: %2F)
   * 5. Tentativas de path traversal (ex: ../)
   * 6. Padrões de domínio após barras duplas (ex: //example.com)
   */
  const isMalicious =
    /^\/{2,}/.test(path) || // Verifica duas ou mais barras no início
    /\\|%5[Cc]/.test(path) || // Verifica barras invertidas ou codificadas
    /^https?:\/\//i.test(path) || // Verifica protocolos HTTP/HTTPS
    /%2[Ff]/.test(path) || // Verifica barras codificadas
    /\.\.\//.test(path) || // Verifica tentativas de path traversal
    /\/\/.+\./.test(path) // Verifica domínios após barras duplas

  // Se detectado padrão malicioso, redireciona para página 404 (ou home)
  if (isMalicious) {
    return redirect(404, '/')
  }

  /**
   * Normalização de URLs que terminam com barra:
   * - Remove barras redundantes no final do path
   * - Mantém a query string e hash originais
   * - Redireciona com status 301 (Permanently Moved)
   */
  if (path !== '/' && path.endsWith('/')) {
    // Remove todas as barras no final do path (mantém pelo menos '/')
    let nextPath = path.replace(/\/+$/, '') || '/'
    // Cria objeto de rota para o redirecionamento
    const nextRoute = { path: nextPath, query, hash }

    // Executa redirecionamento permanente (301)
    return redirect(301, nextRoute)
  }
}
